<div class="content-wrapper">
    <section class="content">
      <div class="box">
        <div class="box-body">
          <form [formGroup]="LocationRecordsForm" (ngSubmit)="LoadAllLocationMasterList()">
            <div class="panel panel-default">
              <header class="panel-heading">
                <h5 class="panel-title">Location Master View</h5>
              </header>             
              <header class="panel-heading">
                <h5 class="panel-title">Search Criteria</h5>
              </header>
              <div class="panel-body">
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Location</label>
                    <p-dropdown [options]="locationList" placeholder="--Select Location Name--"
                    formControlName="LocationID" filter="true">
                  </p-dropdown>                   
                  </div>
                  <div class="form-group col-md-6">
                    <label>SPOC Name</label>
                    <input class="form-control" placeholder="SPOC Name" CharOnly formControlName="LocationHead">
                  </div>
                </div>
              </div>
              <div class="panel-footer" style="text-align: right">
                <button mat-stroked-button type="submit">Get Result</button>
                <button mat-stroked-button type="button" (click)="Reset()">Reset</button>
                <button type="button" mat-stroked-button (click)="Export()">Export</button>
                <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
              </div>
            </div>
  
            <div class="tabel-loading-shade" *ngIf="isLoadingResults">
              <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
            </div>
            <div class="table-container">
              <table mat-table [dataSource]="LocationDataSource" style="width:100% !important">
                <!-- Position Column -->
                <ng-container matColumnDef="Location">
                  <th mat-header-cell *matHeaderCellDef> Location </th>
                  <td mat-cell *matCellDef="let element" style="color: dodgerblue"><a> <span (click)="ShowDetails(element.RequestEntityId)" style="display:none">{{element.RequestEntityId}}</span> {{element.Location}}</a>
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="SPOCName">
                  <th mat-header-cell *matHeaderCellDef> SPOC Name </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.SPOCName}} </td>
                </ng-container>

                <ng-container matColumnDef="Email">
                  <th mat-header-cell *matHeaderCellDef> Email ID </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.Email}} </td>
                </ng-container>
  
                <ng-container matColumnDef="PhoneNo">
                  <th mat-header-cell *matHeaderCellDef> Phone </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.PhoneNo}} </td>
                </ng-container>               
  
  
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                  (click)="ShowDetails(row)"></tr>
              </table>
            </div>
          </form>
          <mat-paginator [length]="_global.length" (page)="onPaginateChange($event)"></mat-paginator>
          <div style="float:right;">Page : <input type="text" numbersOnly style="width:50px;height:10px;"
              [(ngModel)]="_global.pageIndex" /> of {{_global.totalPage}} &nbsp;&nbsp;&nbsp;&nbsp;<button type="button"
              mat-stroked-button (click)="GoToPage()">Go</button></div>
        </div>
      </div>
    </section>
  </div>